import { Component, OnInit, Input, Output, TemplateRef, ViewContainerRef, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-dialog-body',
    templateUrl: './dialog-body.component.html',
    styleUrls: ['./dialog-body.component.css'],
    standalone: false
})
export class DialogBodyComponent implements OnInit {
    @Input() template: TemplateRef<any>;
    @Input() isLoadingEnable: boolean = false;
    @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
    constructor(private vcr: ViewContainerRef) {}

    ngOnInit() {
        this.vcr.createEmbeddedView(this.template);
        // this.dialogService.getBodyEvent().subscribe((data)=>{
        //   this.onClick(data);
        // });
    }

    onClick(data) {
        this.clicked.emit(data);
    }
}
